declare var google: any;
declare var FB: any;

import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SocialUser } from '../wizard/wizard.component';

@Component({
  selector: 'app-social-login',
  templateUrl: './social-login.component.html',
  styleUrls: ['./social-login.component.css']
})
export class SocialLoginComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SocialLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private ngZone: NgZone) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSocialLogin(res: any): void {
    console.log("Social Login Completed");
    let socialUserData = JSON.parse(atob(res.credential.split('.')[1]));
    let socialUser: SocialUser = {
      firstName: socialUserData.given_name,
      token: res.credential,
      tenantKey: localStorage.getItem('tenant'),
      lastName: socialUserData.family_name,
      email: socialUserData.email,
      platform: "WEB",
      timeZone: "",
      device: "",
      authProvider: "google"
    };
    this.ngZone.run(() => {
      this.dialogRef.close(socialUser);
    });
  }

  ngOnInit(): void {
    google.accounts.id.initialize({
      client_id: "196972985831-fma8p5mvuhhrl3tkrhpborng0094f48o.apps.googleusercontent.com",
      callback: this.onSocialLogin.bind(this)
    });

    google.accounts.id.renderButton(
      document.getElementById("buttonDiv"),
      { theme: "outline", size: "large" }  // customization attributes
    );
  }

  checkLoginState() {

  }

  loginWithFacebook(): void {
    FB.login((response: any) => {
      if (response.authResponse) {
        let accessToken = response.authResponse.accessToken; // Get the token
        FB.api('/me', { fields: 'id,first_name,last_name,name,email,picture' }, (userInfo: any) => {
          console.log('User Info:', userInfo);
          console.log('Access Token:', accessToken);
          let socialUser: SocialUser = {
            firstName: userInfo.first_name,
            token: accessToken,
            tenantKey: localStorage.getItem('tenant'),
            lastName: userInfo.last_name,
            email: userInfo.email,
            platform: "WEB",
            timeZone: "",
            device: "",
            authProvider: "facebook"
          };
          this.ngZone.run(() => {
            this.dialogRef.close(socialUser);
          });
        });
      } else {
        this.dialogRef.close();
        console.error('User cancelled login or did not authorize.');
      }
    }, { scope: 'email,public_profile' });
  }

  // loginWithFacebook(): Promise<any> {
  //   console.log("facebook login");

  //   return new Promise((resolve, reject) => {
  //     FB.login((response: any) => {
  //       if (response.authResponse) {
  //         FB.api('/me', { fields: 'id,name,email,picture' }, (userInfo: any) => {
  //           resolve(userInfo);
  //         });
  //       } else {
  //         reject('User cancelled login or did not fully authorize.');
  //       }
  //     }, { scope: 'email,public_profile' });
  //   });
  // }

}
